import { render, staticRenderFns } from "./type-sort.vue?vue&type=template&id=52b81a2c&"
import script from "./type-sort.vue?vue&type=script&lang=js&"
export * from "./type-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports